import React from "react";
import { useLocation } from "react-router-dom";

export default function VideoPlayer() {

  const location = useLocation();
  const url = location.state?.url;

  if (!url) {
    return <h3>No video selected</h3>;
  }

  return (

    <div style={{ padding: "10px" }}>

      <iframe
        src={url}
        width="100%"
        height="500"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
        title="Video Player"
      ></iframe>

    </div>

  );
}
